import { ConnectionCalendar, ExternalConnection } from '@griply/types';

import { canConnectionWriteEvents } from './can-connection-write-events';

export type GetWritableConnectionCalendarsOptions = {
  // also drop calendars the provider itself marked read-only
  requireCalendarWrite?: boolean;
};

// Providers return their calendars in an order of their own, which put a random calendar at the
// top of every picker — and made it the create form's default, since that reads the first entry.
// The id tiebreak keeps two same-named calendars (the same "Personal" on two accounts) in one
// order on both engines.
const byName = (a: ConnectionCalendar, b: ConnectionCalendar) =>
  (a.name || '').localeCompare(b.name || '') ||
  a.connectionId.localeCompare(b.connectionId) ||
  a.id.localeCompare(b.id);

export const getWritableConnectionCalendars = (
  connections: ExternalConnection[],
  calendars: ConnectionCalendar[],
  { requireCalendarWrite }: GetWritableConnectionCalendarsOptions = {},
): ConnectionCalendar[] => {
  const writableConnectionIds = connections
    .filter(canConnectionWriteEvents)
    .map(({ id }) => id);

  return calendars
    .filter(
      (calendar) =>
        writableConnectionIds.includes(calendar.connectionId) &&
        (!requireCalendarWrite || calendar.canWrite !== false),
    )
    .sort(byName);
};
